import { FC } from "react";

export interface TableRowData {
  value?: string | number | boolean | null;
  colorClass?: string;
  iconValue?: string;
}

interface TableRowProps {
  rowData: TableRowData[];
}

export const TableRow: FC<TableRowProps> = ({ rowData }: TableRowProps) => {
  const renderIcon = (iconValue: string) => {
    return (
      <span className="material-icons-outlined text-gray-500">{iconValue}</span>
    );
  };

  return (
    <>
      {rowData.map((data, index) => (
        <td
          className="py-6 border-0 border-b border-solid border-gray-200"
          key={index}
        >
          {data.iconValue ? (
            renderIcon(data.iconValue)
          ) : (
            <p className={`text-base ${data.colorClass || ""}`}>{data.value}</p>
          )}
        </td>
      ))}
    </>
  );
};
